<template>
  <div class="zj-moble-app-page event-report">
    <div class="position_header">
      <div class="header_info">我的位置：{{ Location }}</div>
      <div class="header_info_r" @click="getlocationpoint">
        <img
          slot="icon"
          src="../images/icon_shangbaoweizhi.png"
          :style="{ height: '0.28rem', width: '0.28rem' }"
        />
        <span>重新定位</span>
      </div>
      <div class="container">
        <div id="allmap" class="map"></div>
        <p class="errortext" ref="errtext"></p>
      </div>
    </div>
    <!--  <mt-header class="zj-mt-header white" fixed="true" :title="Location" slot="left">
      <mt-button slot="left" icon="back" @click.native="GotoBack" class="nav-btn black">我的位置：</mt-button>
      <mt-button slot="right" icon="more" class="nav-btn blue" size="small">
        <img
          slot="icon"
          src="../images/icon_shangbaoweizhi.png"
          :style="{ height:'2.5rem',width:'2.5rem'}"
        />
        上报位置
      </mt-button>
    </mt-header> -->
    <div class="zj-mt-content padding">
      <!-- 顶部tab切换 -->
      <div
        style="display: flex; justify-content: flex-start; align-items: center"
      >
       <div class="leftBtn" @click="tabSwitch('first')">
          <div class="btnFont " :class="{activeTab:activeTabDom === 'first'}">我的任务</div>
          <div class="btnStyle" v-show="activeTabDom === 'first'"></div>
          <div class="btnStyle2" v-show="activeTabDom === 'second'"></div>
        </div>
       <div class="rightBtn" @click="tabSwitch('second')"  style="margin-left: 0.3rem">
          <div class="btnFont" :class="{activeTab:activeTabDom === 'second'}">事态反馈</div>
          <div class="btnStyle" v-show="activeTabDom === 'second'"></div>
          <div class="btnStyle2" v-show="activeTabDom === 'first'"></div>
        </div>
       
      </div>
      <mt-tab-container v-model="activeTabDom" swipeable>
       
        <mt-tab-container-item id="first">
          <div style="margin-top: 200px" v-if="taskArr.length == 0">
            <img
              style="margin: 0 auto; display: block"
              src="../images/zanwurenwu.png"
            />
            <p class="spaceTxt">当前暂无待执行任务</p>
          </div>
          <div v-if="taskArr.length > 0">
            <div class="listOutline" v-for="item in taskArr" :key="item.Id" >
              <!-- 状态图标 -->
              <!-- v-if="noComTask.length>0" -->
              <div class="statusIcon" :class="{'statusNozhi':item.status == '1',statuszhixing:item.status == '3',statuswancheng:item.status == '2'}"></div>
                <div class="topBox" @click="goHome(item)">
                  <ul>
                    <li class="topLi">{{ item.taskName }}</li>
                    <li class="dateLi">
                      {{ item.modifydate || item.createdate }}
                    </li>
                  </ul>
                  <div class="lineBlue"></div>
                </div>
                <div class="middleInfo"  @click="goHome(item)">
                  {{ item.TaskDesc == "" ? "任务详情暂无" : item.taskDesc }}
                </div>
                <ul class="btmInfo"  @click="goHome(item)">
                  <li class="">
                    对接人：{{
                      item.ChargerName == "" ? "暂无信息" : item.personIdTranslated
                    }}
                  </li>
                  <li class="">{{ item.mobileNo }}</li>
                </ul>
              <div class="btn feedbackBtn" @click="goto(item)" :class="{feedbackBtn:item.status == '1',switchBtn:item.status == '3',renwuBtn:item.status == '2'}"></div>
            </div>
          </div>
        </mt-tab-container-item>
        <mt-tab-container-item class="event-report" id="second">
          <div>
            <mt-field
              label="反馈内容"
              v-model="content"
              placeholder="请填写您要反馈的内容"
              type="textarea"
              rows="4"
            ></mt-field>
          </div>
          <div class="media-section">
            <div class="section-title">图片</div>
            <nutimagepicker
              :imgList.sync="imgList"
              delMode="longtap"
              longTapTime="1000"
              :autoUpload="true"
            ></nutimagepicker>
          </div>
          <div class="media-section">
            <div class="section-title">短视频</div>
            <nutvideopicker
              :imgList.sync="videoList"
              accept="video/*"
              delMode="longtap"
              longTapTime="1000"
              :autoUpload="true"
            ></nutvideopicker>
          </div>
          <!-- <div class="media-section">
            <div class="section-title">语音</div>
            <nutimagepicker
              :imgList.sync="audioList"
              accept="audio/*"
              delMode="longtap"
              longTapTime="1000"
            ></nutimagepicker>
          </div>-->
          <!-- 事态反馈提交按钮 -->
          <div class="zj-mt-footer">
            <mt-button
              type="danger"
              :attr="{ maxlength: 10 }"
              @click.native="submit"
              size="middle"
              >提交</mt-button
            >
          </div>
        </mt-tab-container-item>
      </mt-tab-container>
    </div>

    <remote-script
      src="//api.map.baidu.com/api?v=3.0&ak=ERZS9uzwv1zEBuSEAxN5DM5qjZBVHIfq"
    ></remote-script>
    <remote-script
      src="http://developer.baidu.com/map/jsdemo/demo/convertor.js"
    ></remote-script>
  </div>
</template>
<script>
import ZJApp from "../../../app";
import MyApis from "../../../../../plugins/emergency/src/apis";
import { uploadFile } from "@/api/src/emergency_common";
import { getDictionary } from "@/api/src/emergency_common";
import { listByPerson } from "@/api/src/emergency_command_task";
import { save } from "@/api/src/emergency_feedback";
import { update } from "@/api/src/emergency_command_task";
import { detail as personDetail } from "@/api/src/emergency_person";
import "./component/importjs";
import nutimagepicker from "../../../components/imagepicker/imagepicker.vue";
import "../../../components/imagepicker/imagepicker.scss";
import nutvideopicker from "../../../components/imagepicker/videopicker.vue";
import "../../../components/imagepicker/videopicker.scss";
// eslint-disable-next-line no-unused-vars
import { Field, Cell, Toast, Indicator } from "mint-ui";
import waitAll from "../../../../../utils/src/waitAll";

export default {
  name: "EventsReport",
  controller: "UI",
  action: "EventsReport",
  components: {
    nutimagepicker,
    nutvideopicker,
  },
  props: {
    query: {
      //任务执行id
      ExecutTaskId: {
        type: String,
        require: true,
        default: "",
      },
      ExecutId: {
        type: String,
        require: true,
        default: "",
      },
      from: {
        type: String,
        require: false,
        default: "",
      },
    },
  },
  data() {
    return {
      Location: "",
      content: "",
      // Feedback: {
      //   content: ""
      // },
      activeTabDom: "first",
      imgList: [],
      videoList: [],
      audioList: [],
      msgkey: {
        emergencyFeedbackKey: "MessageKey_EmergencyFeedBack",
      },
      Task: this.$props.query.task ? JSON.parse(this.$props.query.task) : {},
      tast: "",
      noComTask: [],
      latitude: "",
      longitude: "",
      options: {
        enableHighAccuracy: true, // --->是否获取更精确的位置  true/false
        timeout: 5000, // --->请求超时时间,单位ms；
        maximumAge: 0,
      },
      taskArr: [],
      optionsObj:{},
      smsPersonIdTranslated:'',
    };
  },
  created() {
    let activeTabDom = this.$route.query.activeTabDom;
    if (activeTabDom) {
      this.activeTabDom = activeTabDom;
    }
    this.getlocationpoint();
    this.getDictionary();
    this.getTask();
    if(this.query.smsPersonId){
      this.getPersonInfo()
    }
    // 百度地图API功能
    // this.$nextTick(() => {
    //   this.getLocation();
    //   let watch1 = window.navigator.geolocation.watchPosition(this.getLocation); // watchPosition()方法：不停的获取和更新用户的地理位置信息，执行间隔时间0ms；当设备地理位置发生改变时，自动调用；  好像删除也么有影响
    //   console.log(watch1);
    //   //清除watch1
    //   window.navigator.geolocation.clearWatch(watch1);
    // });
  },
  methods: {
    GotoBack() {
      this.$router.back(-1);
    },
    getPersonInfo(){
      personDetail( this.query.smsPersonId )
        .then(r => {
          r = r.data;
          this.smsPersonIdTranslated = r.name;
        })
    },
    getDictionary() {
      return getDictionary('emergency_command_status')
        .then(res => {
          if (res.code == "0" && res.data.records != null) {
            let optionsObj ={}
            res.data.records.map(item =>{
              optionsObj[item.code] = item.value
            })
            this.optionsObj = optionsObj
          }
        })
    },
    goHome(item){
        this.$router.push({
          path: "/m/emg/home",
          query: {
            eventId:item.eventId, 
            taskId:item.id, 
            smsPersonId:this.query.smsPersonId || '', 
            personId:this.query.personId || '', 
          }
        });
    },
    goto(item){
      if(item.status == 3){
        this.tabSwitch('second')
        if(item.taskId != this.Task.taskId){
          this.$router.replace({
            path: "/m/emg/EventsReport",
            query: {
              personId:this.query.personId || '', 
              smsPersonId:this.query.smsPersonId || '', 
              task: JSON.stringify(item)
            }
          });
          this.resetForm()
        }
      }else{
        this.goHome(item)
      }
    },
    resetForm(){
      this.content = ''
      this.imgList = []
      this.videoList = []
      this.audioList = []
    },
    getlocationpoint() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          this.showPosition,
          this.showError
        );
      } else {
        alert("该浏览器不支持地理位置!");
      }
    },
    showPosition(position) {
      const that = this;
      //GPS经纬度
      let x = position.coords.latitude;
      let y = position.coords.longitude;
      // eslint-disable-next-line no-undef
      var gpsPoint = new BMap.Point(y, x);
      setTimeout(function () {
        // eslint-disable-next-line no-undef
        // BMap.Convertor.translate(gpsPoint, 0, this.translateCallback(res));
        // eslint-disable-next-line no-undef
        BMap.Convertor.translate(gpsPoint, 0, function (resPoint) {
          if (resPoint) {
            y = resPoint.lng;
            x = resPoint.lat;
          }

          that.latitude = x;
          that.longitude = y;
          // eslint-disable-next-line no-undef
          const point = new BMap.Point(y, x);
          // eslint-disable-next-line no-undef
          const geo = new BMap.Geocoder(); // --> 创建BMap.Geocoder 实例
          let pt = point;

          geo.getLocation(pt, function (rs) {
            /** addressComponents对象可以获取到详细的地址信息 */
            let addComp = rs.addressComponents;
            console.log(addComp);
            let site =
              addComp.province +
              addComp.city +
              addComp.district +
              addComp.street +
              addComp.streetNumber;

            that.Location = site;
          });
        });
      }, 1000);
    },

    showError(error) {
      switch (error.code) {
        case error.PERMISSION_DENIED:
          alert("用户拒绝对获取地理位置的请求。");
          break;
        case error.POSITION_UNAVAILABLE:
          alert("位置信息是不可用的。");
          break;
        case error.TIMEOUT:
          alert("请求用户地理位置超时。");
          break;
        case error.UNKNOWN_ERROR:
          alert("未知错误。");
          break;
      }
    },
    getTask() {
      let { eventId,personId } = this.Task;
      let ExecutTaskSearch = {
          eventId,
          current:1,
          size:100,
        };
      if (this.query.smsPersonId) {
        ExecutTaskSearch.smsPersonId = this.query.smsPersonId
      }
      if (this.query.personId) {
        ExecutTaskSearch.personId = this.query.personId
      }
      return listByPerson(ExecutTaskSearch)
        .then((res) => {
          if (res.code == "0" && res.data.records != null) {
            var result = res.data.records;
            let arr1=[],arr2=[],arr3=[],arr4=[]
            result.map(item =>{
              if(item.status == '1'){
                arr1.push(item)
              }else if(item.status == '3'){
                arr2.push(item)
              }else if(item.status == '2'){
                arr3.push(item)
              }else{
                arr4.push(item)
              }
            })
            arr1 = this.sortData(arr1)
            arr2 = this.sortData(arr2)
            arr3 = this.sortData(arr3)
            arr4 = this.sortData(arr4)
            // eslint-disable-next-line no-undef
            this.taskArr = [...arr1,...arr2,...arr3] || [];
          }
        })
    },
    sortData(arr){
      if(arr.length > 0){
       arr = arr.sort(function (a, b) {
        a = a.modifydate || a.createdate
        b = b.modifydate || b.createdate
                if (a && b) {
                    return Date.parse(b) - Date.parse(a)
                }
            })
      }
      return arr
    },
    choseimg() {},
    tabSwitch(tab) {
      console.log(tab);
      this.activeTabDom = tab;
    },
    submit: function () {
      let that = this;

      if (!that.content) {
        Toast({ message: "请填写你要反馈的内容" });
        return false;
      }

      that.submitFeedback();
    },
    submitFeedback() {
      let that = this;
      let uuid = ZJApp.ZJUtils.uuid();

      Indicator.open({
        text: "反馈上传中...",
        spinnerType: "triple-bounce",
      });
      //插入反馈数据
      save(that.newfeedback())
        .then((r) => {
          let code = r.code;
          if (code == 0) {
            //增加反馈成功，发送反馈成功消息
            that.$notify.broadcase({
              key:
                that.msgkey.emergencyFeedbackKey + that.Task.ExecutId,
              data: that.feedback,
            });

            Indicator.close();
            Toast({ message: "事态反馈成功" });
            this.resetForm()
          }
        })
    },
    newfeedback: function () {
      let user = this.Task.smsPersonId ? this.smsPersonIdTranslated : this.Task.personIdTranslated;
      var feedback = {
        createUser: user,
        status: this.Task.status,
        taskId: this.Task.id,
        eventId: this.Task.eventId,
        feedbackType: "1", //反馈类型(1-现场反馈2-任务执行3启动应急预案)
        content: this.content,
        imgs:this.imgList.map(item=>item.src).join(','),
        videos:this.videoList.map(item=>item.src).join(',')
      };
      return feedback;
    },
  },
};
</script>
<style type="text/css" scoped>
.add-image {
  width: 50px;
  height: 50px;
  background-image: url(/images/addImg.png);
  background-size: 100%;
}
.position_header {
  width: 100%;
  height: 0.75rem;
  background: #fff;
  color: #333;
  padding: 0 0.3rem;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.header_info {
  font-size: 0.28rem;
  text-align: left;
  flex: 1;
}
.header_info_r {
  width: 1.5rem;
  height: 100%;
  line-height: 0.75rem;
  font-size: 0.28rem;
  color: #2c91eb;
  font-weight: bold;
  display: flex;
  align-items: center;
  margin-left: 0.2rem;
}
.btnStyle {
  width: 0.61rem;
  height: 4px;
  background-color: #2c91eb;
  border-radius: 30px;
  margin: 0.12rem auto 0;
}
.btnStyle2 {
  width: 0.61rem;
  height: 4px;
  background-color: transparent;
  margin: 0.12rem auto 0;
}
.btnFont {
  color: #3d4146;
  font-size: 0.3rem;
}
.activeTab {
  font-size: 0.34rem;
  font-weight: bold;
}
.spaceTxt {
  color: #3c3c3c;
  font-size: 0.34rem;
  font-weight: bold;
  text-align: center;
  margin-top: 0.4rem;
}
.listOutline {
  /*width: 6.9rem;*/
  width: 100%;
  height: 3.8rem;
  background-color: #fff;
  position: relative;
}
.statusIcon {
  position: absolute;
  right: 0;
  top: 0;
  width: 1.43rem;
  height: 1.46rem;
}
.statusNozhi {
  background: url("../images/1_daizhixing.png") no-repeat;
  background-size: cover;
}
.statuszhixing {
  background: url("../images/2_weiwancheng.png") no-repeat;
  background-size: cover;
}
.statuswancheng {
  background: url("../images/3_yiwancheng.png") no-repeat;
  background-size: cover;
}
.topBox {
  position: relative;
  padding-top: 0.3rem;
  padding-left: 0.5rem;
}
.topLi {
  font-size: 0.32rem;
  font-weight: bold;
  color: #3d4146;
  list-style: none;
}
.dateLi {
  font-size: 0.28rem;
  color: #333;
  line-height: 0.5rem;
  list-style: none;
}
.lineBlue {
  position: absolute;
  width: 0.06rem;
  height: 0.74rem;
  background-color: #2c91eb;
  left: 0.3rem;
  top: 0.36rem;
}
.middleInfo {
  width: 4.76rem;
  margin-left: 0.3rem;
  margin-top: 0.15rem;
  word-break: break-all;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2; /**显示的行数**/
  overflow: hidden; /**隐藏超出的内容**/
  font-size: 0.28rem;
  color: #999;
}
.btmInfo {
  position: absolute;
  left: 0.3rem;
  bottom: 0.3rem;
}
.btmInfo li {
  font-size: 0.28rem;
  color: #999999;
  line-height: 0.46rem;
  list-style: none;
}
.btn{
   width: 2.76rem;
  height: 1.46rem;
  position: absolute;
  right: 0rem;
  bottom: 0rem;
}
.feedbackBtn {
  background: url("../images/feedback.png") no-repeat;
  background-size: 100% 100%;
}
.switchBtn{
  background: url("../images/feedback_bg.png") no-repeat;
  background-size: 100% 100%;
}
.renwuBtn{
  background: url("../images/renwu.png") no-repeat;
  background-size: 100% 100%;
}
</style>